import logError from '@/helpers/logError';
import { ImageFile, PictureStepActionPayload } from '../../../state';
import { HubspotFile } from '@/helpers/hubspot/types';

export function updatePerfectlyMatchedImages(
	a: ImageFile[],
	b: PictureStepActionPayload['END_HUBSPOT_FILE_UPLOAD'],
): [ImageFile[], ImageFile[], HubspotFile[]] {
	try {
		// Matched and updated images
		const a2 = a
			.filter((image) => image.uploadBatchId === b.uploadBatchId)
			.filter((image) => {
				const b2 = b.files.find(
					(file) => `${file.name}.${file.extension}` === `${image.image?.name}`,
				);
				return b2 !== undefined;
			})
			.map((image): ImageFile => {
				let updatedImage = { ...image };

				const b2 = b.files.find(
					(file) =>
						`${file.name}.${file.extension}` === `${updatedImage.image?.name}`,
				);

				updatedImage = {
					...updatedImage,
					id: b2!.id, // I know there is one, becuase I've filtered for it.
					inProgress: false,
				};
				return updatedImage;
			});

		// Unmatched images
		const a3 = a
			.filter((image) => image.uploadBatchId === b.uploadBatchId)
			.filter((image) => {
				const b2 = b.files.find(
					(file) => `${file.name}.${file.extension}` === `${image.image?.name}`,
				);
				return b2 === undefined;
			})
			.map(
				(image): ImageFile => ({
					...image,
					inProgress: false,
					error: `Oops, this file got stuck. Feel free to skip this step, we'll follow up with you!`,
				}),
			);

		// Unmatched responses
		const b3 = b.files.filter(
			(file) =>
				!a.find(
					(image) =>
						image.image?.name === `${file.name}.${file.extension}` &&
						!image.id &&
						image.uploadBatchId === b.uploadBatchId,
				),
		);
		return [a2, a3, b3];
	} catch (error) {
		if (error instanceof Error) {
			logError(error);
		} else {
			logError(new Error('Failed to match images'));
		}
		return [[], a, b.files];
	}
}
